import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

type OptionType = {
	label: string;
	value: string | number | boolean
}

interface CustomRadioButtonProps {
	legend: string;
	options: Array<OptionType>;
	name?: string;
	defaultValue: string | number | boolean
	handleChange: (event: any) => void;
}

const CustomRadio = (props: CustomRadioButtonProps) => {
	const { legend, options, defaultValue, name } = props;
  return (
	<FormControl component="fieldset">
	  <FormLabel component="legend">{legend}</FormLabel>
	  <RadioGroup
	  	row
		aria-label={`${legend}`}
		name={name}
		defaultValue={defaultValue}
		onChange={props.handleChange}
		>
		  {options.map((option: OptionType) => 
		  	<FormControlLabel
			  value={option.value}
			  control={<Radio />}
			  label={option.label} 
			/>
		  )}
	  </RadioGroup>
	</FormControl>
  );
}

export default CustomRadio;
